<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file AccountTickets.vue is part of event_pass_client.dev.            -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - AccountTickets.vue can not be copied and/or distributed                   -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 22/03/2018-->
<!--//Time: 14:57-->

<template>
    <div>
        <div data-tickets-list class="d-flex justify-content-between flex-column flex-md-row pb-2">
            <div class="d-flex w-100">
                <div class="w-25">
                    <div class="d-inline-block ticket-icon">
                        <div :class="ticketTypeIconClass(sale[0].finalized_ticket)"
                        ></div>
                    </div>
                </div>

                <ticket-details-list
                        class="w-50"
                        :ticket="sale[0].finalized_ticket"
                        :show_icon="false"
                        :show_time="true"
                />
            </div>
            <div class="w-25 ">
                <span>
                    <i class="fa fa-car"></i>
                    <b>{{sale.length}}</b>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
	import {ticket_types} from '../../../../../../app/Shared/Resources/Assets/js/helpers/ticketIcons';
	import lang from '../../../../../../app/Shared/Resources/Assets/js/helpers/lang';
	import {_} from 'underscore';

	Vue.component('ticket-details-list', require('../../tickets/TicketDetailsList'));
	Vue.component('event-list', require('../../lists/EventList'));

	export default {
		name: "account-vip-ickets",
		components: {},
		props: ['routes', 'sale', 'events'],
		created() {
		},
		destroyed() {
		},
		mounted() {
		},
		data() {
			return {}
		},
		methods: {
			first(events) {
				return _.first(events);
			},
			size(obj) {
				return _.size(obj);
			},
			ticketTypeIconClass(ticket) {
				return ticket_types(ticket.ticket_type, false, 'bg');
			},
			lang(path, object) {
				// console.log('path',path);
				return lang(path, object)
			},
			debug(obj) {
				console.log('obj', obj);
			}
		},
		computed: {}
	}
</script>

<style scoped>

    .ticket-icon {
        height: 40px;
        width: 40px;
        font-size: 40px;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/account/AccountVIPTickets.vue